import AutoQuery from 'servicestack/auto-query/auto-query'
import ServiceBus from 'servicestack/service-bus'
import BasicController from 'servicestack/basic.controller'
import $session from 'servicestack/session'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import templateUrl from 'servicestack/video-message/video-message-prompt.htm'
import config from 'emun.customer/customer.config'

function VideoMessagePromptController($rootScope, $uibModalInstance, options) {
    var $ctrl = this;
    var model = $ctrl.model = options.model;
    var bus = $ctrl.bus = new ServiceBus($rootScope);
    $ctrl.title = 'Record Video...';
    $ctrl.config = config;

    $ctrl.videoFormats = [
        {
            label: "Screen Only (without audio)",
            options: {
                enableScreen: true
            }
        },
        {
            label: "Screen + Microphone",
            options: {
                enableScreen: true,
                enableMicrophone: true
            }
        },
        {
            label: "Screen + Speakers",
            options: {
                enableScreen: true,
                enableSpeakers: true
            }
        },
        {
            label: "Screen + Microphone + Speakers",
            options: {
                enableScreen: true,
                enableMicrophone: true,
                enableSpeakers: true
            }
        },
        {
            label: "Chrome Tab",
            options: {
                enableTabCaptureAPI: true
            }
        },
        {
            label: "Chrome Tab (audio only)",
            options: {
                enableTabCaptureAPI: true,
                enableTabCaptureAPIAudioOnly: true
            }
        },
        {
            label: "Full Screen + Camera",
            options: {
                enableScreen: true,
                enableCamera: true
            }
        },
        {
            label: "Microphone + Camera",
            options: {
                enableMicrophone: true,
                enableCamera: true
            }
        },
        {
            label: "Microphone + Speakers",
            options: {
                enableMicrophone: true,
                enableSpeakers: true
            }
        },
        {
            label: "Microphone Only",
            options: {
                enableMicrophone: true
            }
        },
        {
            label: "Speakers Only",
            options: {
                enableSpeakers: true
            }
        }
    ];

    $ctrl.selectedVideoFormat = $ctrl.videoFormats[7];

    if (options.title) {
		$ctrl.title = options.title;
	}

    $ctrl.delete = function() {
        $uibModalInstance.close($ctrl.model);
        return modals.confirm("Are you sure?", "Delete Note").result.then(function () {
            $ctrl.bus.send('DeleteEntityMessage.json', $ctrl.model.message).then(function (response) {
                $rootScope.$emit('entityMessageDeleted', $ctrl);
            });
        });
    }
    $ctrl.dismiss = function () {
        $uibModalInstance.dismiss();
    };

    $ctrl.record = function() {
        const $ctrl = this;
        $ctrl.recording = true;
        if(typeof RecordRTC_Extension === 'undefined') {
            modals.alert('RecordRTC chrome extension is either disabled or not installed.');
        }
        
        $ctrl.recorder = new RecordRTC_Extension();
        $ctrl.recorder.startRecording($ctrl.selectedVideoFormat.options, function() {
        });
    }
    $ctrl.stopRecording = function() {
        const $ctrl = this;
        $ctrl.recording = false;
        $ctrl.recorder.stopRecording(function(blob) {
            $ctrl.blob = blob;
            $ctrl.file = new File([blob], "video-capture.webm", { type: 'video/webm' });
			var videoPlayer = document.getElementById("video-preview");
			if (videoPlayer) {
                //console.debug("BL*** setting video source");
                videoPlayer.srcObject = null; 
                videoPlayer.src = window.URL.createObjectURL($ctrl.blob);
			}
        });
    }
    $ctrl.save = function() {
        const $ctrl = this;
        $ctrl.files = [];
        $ctrl.files.push($ctrl.file);
        $rootScope.$broadcast('videoRecordingSaved', $ctrl.files);
        $ctrl.dismiss();
    }
}

const VideoMessagePrompt =  {
    open(options) {
        return modals.open(angular.extend({
            size: 'lg',
            templateUrl: templateUrl,
            resolve: {
                options: () => options
            },
            controller: VideoMessagePromptController,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};


export default VideoMessagePrompt;